export default "__VITE_ASSET__$sQIhhFN__"